
import { makeCoverTaskAttachmentService } from '@/services/task'
import { AttachmentType } from '@/types/entities'
import { defineComponent, PropType } from 'vue'

export default defineComponent({
  props: {
    attachment: {
      type: Object as PropType<AttachmentType>,
      required: true
    }
  },
  inject: ['task', 'list', 'updateListTask'],
  methods: {
    async handleMakeAttachmentCover (attachment: AttachmentType) {
      const res = await makeCoverTaskAttachmentService(
        this.$route.params.boardId,
        this.list._id,
        this.task._id,
        attachment._id,
        !attachment.isCover
      )
      if (!res.error) {
        this.updateListTask(res.data)
      }
    }
  }
})
